import { Region } from "./calculation-api.types";
import { FamilyFormState } from "./FamilyFormState";

export enum CalculatorField {
  Region = "Region",
  GrossIncome = "GrossIncome",
  FamilySituation = "FamilySituation",
  SickParent = "SickParent",

  Children = "Children",
  ChildName = "ChildName",
  ChildOldSystem = "ChildOldSystem",
  ChildBirthdate = "ChildBirthdate",
  ChildPlaced = "ChildPlaced",
  ChildRequiresAssistance = "ChildRequiresAssistance",
  ChildHandicap = "ChildHandicap",
  ChildHasDeadParents = "ChildHasDeadParents",
  ChildOrphanAfter2018 = "ChildOrphanAfter2018",
  ChildOneOrBothParentsDead = "ChildOneOrBothParentsDead",
  ChildSingleParentLivesAlone = "ChildSingleParentLivesAlone",
}

type BaseCalculatorQuestion = {
  title?: string;
  explanation?: string;
  description?: string;
  field: CalculatorField;
  // visible is an optional function that can determine the visibility of a question
  visible?: (state: FamilyFormState, region: Region) => boolean;
  // blocking is an optional function that can stop the flow if a certain state is met
  blocking?: (state: FamilyFormState) => boolean;
};

type OptionsCalculationQuestion = BaseCalculatorQuestion & {
  input: "option";
  options: {
    text: string;
    value: string;
    message?: string;
  }[];
};

type InputCalculationQuestion = BaseCalculatorQuestion & {
  input: "string";
};

type DateInputCalculationQuestion = BaseCalculatorQuestion & {
  input: "date",
  options?: {
    value: string;
    message?: string;
  }[];
}

export type CalculatorQuestion =
  | OptionsCalculationQuestion
  | InputCalculationQuestion
  | DateInputCalculationQuestion;

export type CalculatorQuestionInput = Omit<CalculatorQuestion, "options">;

export type CalculatorStep = {
  field: string;
  title: string;
  description?: string;
  questions: CalculatorQuestion[];
};
